import { IconInfo, IconWarning } from "@decibeltrade/react-icons";
import { css } from "styled-system/css";

import type { GlobalAnnouncementConfig } from "@/lib/statsig-configs";

import { Banner } from "./banner";
import { DismissibleAnnouncementBanner } from "./dismissible-announcement-banner";

/**
 * Global announcement banner controlled by Statsig.
 * Server-rendered; only the dismiss logic hydrates on the client.
 */
export function GlobalAnnouncementBanner({
  announcement,
}: {
  announcement: GlobalAnnouncementConfig | null;
}) {
  if (!announcement) return null;

  if (announcement.dismissible) {
    return <DismissibleAnnouncementBanner announcement={announcement} />;
  }

  return <AnnouncementBannerContent announcement={announcement} />;
}

export function AnnouncementBannerContent({
  announcement,
  onDismiss,
}: {
  announcement: GlobalAnnouncementConfig;
  onDismiss?: () => void;
}) {
  const icon =
    announcement.severity === "critical" ? (
      <IconWarning className={css({ h: "16", w: "16", flexShrink: 0 })} />
    ) : (
      <IconInfo className={css({ h: "16", w: "16", flexShrink: 0 })} />
    );

  const variant = announcement.severity === "critical" ? "critical" : "warning";

  return (
    <Banner variant={variant} onDismiss={onDismiss}>
      {icon}
      {announcement.message}
    </Banner>
  );
}
